export default __webpack_public_path__ + "static/media/01_photo.de73153d.jpg";